import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useTableContext } from '../../context';
import { TableCellContentType } from '../../types';
import { Cell } from '../Cell';
import { Row } from '../Row';
import { LoaderBar } from './styled';
export const Loader = memo(function Loader({ rows = 3, dataTestId }) {
    const { columnCount } = useTableContext();
    const rowsArray = useMemo(() => Array.from({ length: rows }, (_, i) => i), [rows]);
    const columnsArray = useMemo(() => Array.from({ length: columnCount }, (_, i) => i), [columnCount]);
    return rowsArray.map((i) => (_jsx(Row, { dataTestId: dataTestId, children: columnsArray.map((j) => (_jsx(Cell, { contentType: TableCellContentType.LOADING, children: _jsx(LoaderBar, {}) }, j))) }, i)));
});
